var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9111 8.20639L10.222 7.48761C10.6308 7.37452 10.9608 7.15209 11.212 6.82033C11.4632 6.48857 11.5888 6.10679 11.5888 5.675C11.5888 5.15705 11.4097 4.71518 11.0515 4.34939C10.6932 3.9836 10.2609 3.80071 9.75465 3.80071H7.44152V2.87544H9.75465C10.5132 2.87544 11.1604 3.14849 11.6963 3.69461C12.2321 4.24062 12.5 4.90075 12.5 5.675C12.5 6.22142 12.3555 6.72061 12.0666 7.17255C11.7776 7.6246 11.3925 7.96921 10.9111 8.20639ZM8.90418 6.13763L7.99296 5.21236H8.9953V6.13763H8.90418ZM11.6776 12L0.5 0.650004L1.14013 0L12.3178 11.35L11.6776 12ZM6.01637 8.47456H3.71493C2.95245 8.47456 2.30234 8.2015 1.76462 7.65539C1.2268 7.10938 0.957888 6.44924 0.957888 5.675C0.957888 4.98937 1.17537 4.38774 1.61032 3.8701C2.04528 3.35257 2.59105 3.04003 3.24763 2.93249H3.38781L4.24299 3.80071H3.71493C3.20475 3.80071 2.76959 3.9836 2.40946 4.34939C2.04922 4.71518 1.86911 5.15705 1.86911 5.675C1.86911 6.19295 2.04922 6.63481 2.40946 7.0006C2.76959 7.36639 3.20475 7.54929 3.71493 7.54929H6.01637V8.47456ZM4.46259 6.13763V5.21236H5.64247L6.5385 6.13763H4.46259Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnected);
export default __webpack_public_path__ + "static/media/disconnected.d1fe9c44.svg";
export { ForwardRef as ReactComponent };